import React, { useContext } from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { withRouter } from 'react-router-dom'

import ErrorMessageContent from './ErrorMessageContent'
import { DevErrorViewContext } from 'components/Errors/DevErrorView'

import 'styles/status-message.pcss'
import './invalid-fields.pcss'

const DEV_TEST_DATA = {
    invalidFields: ['firstName', 'lastName']
}

const InvalidFields = ({ t, appError }) => {
    let data = appError.data

    const devErrorContext = useContext(DevErrorViewContext)

    if (devErrorContext) {
        data = DEV_TEST_DATA
    }

    return (
        <ErrorMessageContent
            content={(
                <div className="invalid-fields">
                    <p>
                        {t(`errors:omanettix.${appError.code}.message`)}
                    </p>
                    <br />
                    <strong>{t(`errors:omanettix.${appError.code}.custom.title`)}</strong>
                    <ul className="invalid-fields__list">
                        {data.invalidFields.map((fieldName) => {
                            return <li key={fieldName}>{t(`errors:omanettix.${appError.code}.custom.fields.${fieldName}`)}</li>
                        })}
                    </ul>
                </div>
            )}
        />
    )
}

export default withTranslationCustom(['errors', 'formElements'])(withRouter(InvalidFields))
